module.exports = __webpack_public_path__ + "static/NotoSans-ExtraLight-5131f12202c92cc280033f949a796fd2.ttf";